import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CloneProjectDto, ProjectDto } from 'shared';
import { NotificationService } from 'shared';
import { OAuthServiceService } from 'shared';
import { ProjectService } from 'shared';
import { TenantService } from 'shared';
import { TranslateService } from 'shared';

@Component({
    selector: 'archive-project-dialog',
    templateUrl: './archive-project-dialog.component.html',
    styleUrls: ['./archive-project-dialog.component.scss'],
    standalone: false
})
export class ArchiveProjectDialogComponent implements OnInit {

  archiveProjectForm!:UntypedFormGroup;
  _db!:string;

  constructor(private formBuilder: UntypedFormBuilder,
    public _dialogRef: MatDialogRef<ArchiveProjectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private oauthService: OAuthServiceService,
    public translate: TranslateService
    ) { }

  ngOnInit(): void {
    // this.oauthService.userData.subscribe({
    //   next: (data) => {
    //     if (typeof data != undefined && data != null) {
    //       let userRoles = (data as any).role as Array<string>;
    //       userRoles.forEach((role: string) => {
    //         if (role === 'admin') {
    //           this._db = role;
    //         }
    //       });
    //     }
    //   }
    // });
    this.createArchiveProjectForm();
  }

  createArchiveProjectForm(){
    this.archiveProjectForm = this.formBuilder.group({
      id:  this.data[0].id,
      comment: [null, Validators.required],
    });
  }

  isFormValid(){
    return this.archiveProjectForm.valid;
  }

  archiveProject(){

    if(this.archiveProjectForm.valid) {
      this._dialogRef.close(this.archiveProjectForm.value);
    }
  }

  cancel() {
    this._dialogRef.close();
  }
}